//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import FETCHING from  '../../library/fetching'
import UMUM from  '../../library/umum'
import WILAYAH from  '../../library/getWilayah'

import Joi from "joi";
const schema = Joi.object().keys({
  username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(3).max(13).required(),
  password: Joi.string().min(6).required(),
});


export default {
  data() {
    return {

      token : '',

      form : {
        id : '',
        api : '',
        route : '',
        keterangan : '',

      },

      parameter : {
          id : '',
          api_id : '',
          uraian : '',
          type : 'text',
          default : 'null',
          keterangan : '',

      },

      result : [],

      errorMessage: '',
      signingUp : false,
     
      list_data : [],
      list_data_parameter : [],
      list_kecamatan : [],
      list_desa : [],

      page_first: 1,
      page_last: 0,
      page_limit : 10,
      cari_value: "",
      cek_load_data : false,


      mdl_add: false,
      mdl_edit: false,
      mdl_hapus : false,
      mdl_add_parameter: false,
      mdl_edit_parameter: false,
      mdl_hapus_parameter : false,
      btn_add: false,
      mdl_view : false,


      FETCHING : FETCHING,
      UMUM : UMUM,
      WILAYAH : WILAYAH,
    }
  },
  methods: {


      getView : function(){
          this.cek_load_data = true
          fetch(this.$store.state.url.URL_GENERATE_API + "view", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  data_ke: this.page_first,
                  cari_value: this.cari_value,
                  page_limit : this.page_limit,
              })
          })
              .then(res => res.json())
              .then(res_data => {
              console.log(res_data);
                  this.list_data = res_data.data;
                  this.page_last = res_data.jmlData;
                  this.cek_load_data = false
          });
      },
  
  
      addData : function(number) {

          fetch(this.$store.state.url.URL_GENERATE_API + "addData", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.form)
          }).then(res_data => {
              this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
              this.getView();
          });
  
  
  
      },
  
  
      editData : function(){
          fetch(this.$store.state.url.URL_GENERATE_API + "editData", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.form)
          }).then(res_data => {
              this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
              this.getView();
          });
      },
  
      removeData : function(E){
          fetch(this.$store.state.url.URL_GENERATE_API + "removeData", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({id : this.form.id})
          }).then(res_data => {
              this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
              this.getView();
          });
  
      },
  
      selectData : function(data){
        this.form.id = data.id ;
        this.form.api = data.api ;
        this.form.route = data.route ;
        this.form.keterangan = data.keterangan ;

        this.parameter.api_id = data.id

        this.getViewParameter();
      },
  
      generateToken : function(){
          fetch(this.$store.state.url.URL_APP + "auth/crateToken", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.form)
          })
          .then(res => res.json())
          .then(res_data => {
              // this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
              console.log(res_data);
  
              this.token = res_data.token
              // this.getView();
          });
      },



      getViewParameter : function(){
          // this.cek_load_data = true
          fetch(this.$store.state.url.URL_GENERATE_API + "viewParameter", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  api_id: this.parameter.api_id,
              })
          })
              .then(res => res.json())
              .then(res_data => {
              console.log(res_data);
                  this.list_data_parameter = res_data;
          });
      },
  
  
      addDataParameter : function(number) {

          fetch(this.$store.state.url.URL_GENERATE_API + "addDataParameter", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.parameter)
          }).then(res_data => {
              this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
              this.getViewParameter();
          });
  
  
  
      },
  
  
      editDataParameter : function(){
          fetch(this.$store.state.url.URL_GENERATE_API + "editDataParameter", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.parameter)
          }).then(res_data => {
              this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
              this.getViewParameter();
          });
      },
  
      removeDataParameter : function(E){
          fetch(this.$store.state.url.URL_GENERATE_API + "removeDataParameter", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({id : this.parameter.id})
          }).then(res_data => {
              this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
              this.getViewParameter();
          });
  
      },
      selectDataParameter : function(data){
              this.parameter.id = data.id ;
              this.parameter.api_id = data.api_id ;
              this.parameter.uraian = data.uraian ;
              this.parameter.type = data.type ;
              this.parameter.default = data.default ;
              this.parameter.keterangan = data.keterangan ;
      },

      tryAPI_Paramter : function(){

        var url = this.$store.state.url.URL_APP+this.form.api+this.form.route
        var data = {}
        var arr = this.list_data_parameter

        arr.forEach(element => {
          data[element.uraian] = element.value
        });

        this.result = []



        fetch(url, {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(data)
          })
              .then(res => res.json())
              .then(res_data => {

                  this.result = res_data
                  console.log(res_data);
        });




      },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        }


    // ====================================== PAGINATE ====================================







  },

  mounted () {
    this.getView();
  },
}
